import { apiCall } from '../../api/ServerApi';
import { logger } from '../Logger';

const ANALYTICS_PATH = '/analytics';

interface IUsageEventsConfig {
	tenantId: string;
	userId: string;
	productName: string;
	productVersion: string;
	sendEventToggle: boolean;
}

interface IUsageEventsState {
	config: IUsageEventsConfig;
	analyticsUrl: URL | null;
}

let state: IUsageEventsState | null = null;

const buildAnalyticsUrl = (): URL | null => {
	const ingestionUrl = import.meta.env.VITE_INGESTION_URL;
	if (!ingestionUrl) {
		logger.warn('VITE_INGESTION_URL is not configured');
		return null;
	}

	try {
		return new URL(ANALYTICS_PATH, ingestionUrl);
	} catch (error) {
		logger.warn('VITE_INGESTION_URL is invalid', error);
		return null;
	}
};

const init = (params: IUsageEventsConfig): void => {
	state = {
		config: params,
		analyticsUrl: buildAnalyticsUrl()
	};
};

const sendEvent = (eventType: string, payloadOptions: Record<string, unknown> = {}): void => {
	if (!state?.config.sendEventToggle || !state.analyticsUrl) {
		return;
	}

	const { config, analyticsUrl } = state;
	const payload = {
		events: [
			{
				product_name: config.productName,
				product_version: config.productVersion,
				owner_id: config.userId,
				tenant_id: config.tenantId,
				event_id: crypto.randomUUID(),
				event_name: eventType,
				event_timestamp: Date.now() * 1000,
				...payloadOptions
			}
		]
	};

	apiCall('POST', analyticsUrl.href, {
		data: payload,
		isAbsoluteUrl: true
	}).catch((error) => {
		logger.error('Failed to send usage event', error);
	});
};

export const UsageEventsService = {
	init,
	sendEvent
};
